import React from 'react';
import { ProductSelectionDialogHeader } from '@apps/admin/routes/Dashboard/components/DashboardContentV2/ProductSelectionDialog/ProductSelectionDialogHeader/ProductSelectionDialogHeader';
import { DashboardDialog } from '@apps/admin/routes/Dashboard/components/DashboardContentV2/DashboardDialog/DashboardDialog';
import { ProductSelectionDialogFooter } from '@apps/admin/routes/Dashboard/components/DashboardContentV2/ProductSelectionDialog/ProductSelectionDialogFooter/ProductSelectionDialogFooter';
import { ProductSelectionDialogProps } from './ProductSelectionDialog.types';
import { Checkbox, Option, OptionContent, OptionsContainer } from './ProductSelectionDialog.styles';
import { useProductSelectionDialogController } from './ProductSelectionDialog.controller';
import { CheckIcon } from '@assets/icons';

export const ProductSelectionDialog: React.FC<ProductSelectionDialogProps> = ({ isOpen, onClose, refreshDashboardPreview }) => {
  const { title, subtitle, cancelLabel, saveLabel, products, selectedProducts, toggleProduct, handleSave, loadingSaveEventProductVerticals } = useProductSelectionDialogController({
    isOpen,
    onClose,
    refreshDashboardPreview
  });
  const header = <ProductSelectionDialogHeader title={title} subtitle={subtitle} />;
  const footer = (
    <ProductSelectionDialogFooter saveLabel={saveLabel} cancelLabel={cancelLabel} onCancel={onClose} onSave={handleSave} isSaving={loadingSaveEventProductVerticals} />
  );

  return (
    <DashboardDialog header={header} footer={footer} isOpen={isOpen} hasDivider={false} maxWidth="24.375rem" onClose={onClose}>
      <OptionsContainer>
        {products.map(({ label, icon: Icon, id }) => (
          <Option key={id} onClick={() => toggleProduct(id)} role="option" aria-selected={selectedProducts[id] ?? false}>
            <Icon size="xl" />
            <OptionContent textAlign="left" typographyVariant="button2">
              {label}
              <Checkbox selected={selectedProducts[id] ?? false}>
                <CheckIcon />
              </Checkbox>
            </OptionContent>
          </Option>
        ))}
      </OptionsContainer>
    </DashboardDialog>
  );
};
